import React, { createContext, useContext } from 'react';

export const CentreBankingServiceContext = createContext();

// Import the service at module level for production use
import CentreBankingService from '../centreBanking.service';

export const CentreBankingServiceProvider = ({ children }) => {
  return (
    <CentreBankingServiceContext.Provider value={CentreBankingService}>
      {children}
    </CentreBankingServiceContext.Provider>
  );
};

export const useCentreBankingService = () => {
  const context = useContext(CentreBankingServiceContext);
  if (context === undefined) {
    throw new Error('useCentreBankingService must be used within a CentreBankingServiceProvider');
  }
  return context;
};